export default "__VITE_ASSET__D$L$TVBt__"